module.exports = __webpack_public_path__ + "static/img/yiti_02.c871543c.jpg";